// extracted by mini-css-extract-plugin
export default {"root":"pQhiPPsYG3Jx39jt7FSV","size-40":"uuWUMV5gB1YYg00Y2xUJ","size-80":"Z2fLjk2zyngHpEHhkr9q"};